import { IdType } from 'types/common';

export interface PartnerSchemeType {
  id: number;
  name: string;
  pps: PartnerSchemeCommissionType;
  pplns: PartnerSchemeCommissionType;
  token?: string;
  expirationDate?: number;
  isdefault?: boolean;
  status: PartnerSchemeStatusType;
  type: PartnerSchemeClassType;
  beneficiaries?: UserType[];
}

export interface PartnerSchemeCommissionType {
  poolCommission: number;
  beneficiaries?: BeneficiaryType[];
  totalCommission?: number;
}

export interface UserType {
  uid: IdType;
  username: string;
  email: string;
}

export interface BeneficiaryType extends UserType {
  commission: number;
}

export enum PartnerSchemeStatusType {
  ACTIVE = 'active',
  EXPIRED = 'expired',
  DELETED = 'deleted',
}

export enum PartnerSchemeClassType {
  DEFAULT = 'DEF',
  REFERRAL = 'REF',
  REFERRAL_PARTNER = 'REF_P',
  REFERRAL_AMBASSADOR = 'REF_A',
}

export interface PartnerSchemeUserType {
  uid: IdType;
  username: string;
  email: string;
}

export interface PartnerSchemeLogType {
  new: PartnerSchemeType;
  old: PartnerSchemeType;
  updated_by: string;
  updated_by_name: string;
  timestamp: number;
}
